"use client";

import { useAppAvailability } from "@/hooks/use-app-availability";
import { minimumAndroidVersion } from "@/lib/appDownload";

// Version and size come from the manifest CI publishes next to the APK, so a new
// build updates this line on its own - the site does not need rebuilding. A Play
// listing carries its own version and size, so only the requirement is shown.
export default function AppReleaseDetails() {
  const availability = useAppAvailability();

  if (availability.route === "loading" || availability.route === "none") {
    return null;
  }

  const parts =
    availability.route === "apk"
      ? [
          availability.release.version && `Version ${availability.release.version}`,
          availability.release.size,
          minimumAndroidVersion,
        ].filter(Boolean)
      : [minimumAndroidVersion];

  return <p className="mt-4 text-sm text-gray-500">{parts.join(" · ")}</p>;
}
